import { notifyUsageMessage, type PlanUsage, storageUsageMessage, type UsageLevel, type UsageMeter } from "@buildpy/core/modules/plan/usage-limit";

export type KeyStore = Pick<Storage, "getItem" | "setItem">;

export type UsageKind = "storage" | "notify";

const KINDS: readonly UsageKind[] = ["storage", "notify"];

// 닫은 기록 열쇠 — near 는 달(YYYY-MM), over 는 날(YYYY-MM-DD)이 바뀌면 새 열쇠라 다시 뜬다.
export const usageDismissKey = (kind: UsageKind, level: Exclude<UsageLevel, "ok">, today: string): string =>
  level === "near" ? `buildpy:usage-near:${kind}:${today.slice(0, 7)}` : `buildpy:usage-over:${kind}:${today}`;

export const rememberUsageDismiss = (store: KeyStore | null, key: string): void => {
  if (!store) return;
  try {
    store.setItem(key, "1");
  } catch {
    // 저장이 막혀도 이번 화면에서는 닫힌다.
  }
};

export interface UsageAlert {
  kind: UsageKind;
  level: Exclude<UsageLevel, "ok">;
  message: string;
  key: string;
}

// 띄울 경고 — 용량·알림톡 순 · ok 와 한도 없음은 빠진다.
export const usageAlertsOf = (usage: PlanUsage, today: string): UsageAlert[] =>
  KINDS.flatMap((kind) => {
    const meter: UsageMeter = usage[kind];
    const message = kind === "storage" ? storageUsageMessage(meter) : notifyUsageMessage(meter);
    if (meter.level === "ok" || message === null) return [];
    return [{ kind, level: meter.level, message, key: usageDismissKey(kind, meter.level, today) }];
  });
